import React, { useEffect, useState } from "react";
import styles from "./upload-csv.module.css";
import CustomDrawer from "../../../../../../../common/custom-drawer/custom-drawer";
import CustomUpload from "../../../../../../../common/CustomUpload/CustomUpload";
import CustomButton from "../../../../../../../common/custom-button/custom-button";
import { Col, Row, Typography, Upload } from "antd";
import { Controller, useForm } from "react-hook-form";
import { DownloadOutlined } from "@ant-design/icons";
import { sampleTimetableLink } from "../../../../../../../constants/common";
import { toast } from "react-toastify";
import { uploadCsvFile } from "../../../../../../../services/class_routine";

const UploadCsv = ({
  label = "Upload Csv File ",
  onClose,
  open,
  getActivityClassNames,
  accepts,
  onAfterUploadSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const { control, trigger, getValues, reset } = useForm({
    mode: "onChange",
    defaultValues: {
      file: null,
    },
  });

  const handleUploadFile = async () => {
    try {
      const isValid = await trigger();
      if (isValid) {
        const { file } = getValues();
        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        const resp = await uploadCsvFile(formData);
        const activityData = await getActivityClassNames();
        if (activityData && resp?.data?.data) {
          const matchedRecord = activityData?.find(
            (item) => item?.classroom_id === resp?.data?.data?.classroom_id
          );
          if (matchedRecord) {
            onAfterUploadSuccess(matchedRecord);
          }
        }
        onClose();
        toast.success(resp?.data?.message);
      }
    } catch (err) {
      toast.error(err?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      reset({ file: "" });
    }
  }, [open]);
  const sampleFileLink = sampleTimetableLink;
  const sampleFileName = sampleFileLink.split("/").pop();

  return (
    <CustomDrawer
      title={label}
      open={open}
      onClose={() => {
        onClose();
      }}
      width="30vw"
      loading={loading}
      className={styles.drawer}
      drawerStyles={{ body: { padding: 0, margin: 0 } }}
    >
      <div className={styles.layoutMain}>
        <div className={styles.mainLayout}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Controller
                name="file"
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <CustomUpload
                    accepts={accepts}
                    showFileFormats={false}
                    handleBeforeUpload={(file) => {
                      const allowedExtensions = accepts.split(',');
                      const isValid = allowedExtensions.some((ext) =>
                        file.name.toLowerCase().endsWith(ext)
                      );
                      if (!isValid) {
                        toast.error("Only CSV files are allowed!");
                        return Upload.LIST_IGNORE;
                      }
                      onChange(file);
                      return false;
                    }}
                    fileName={value?.name}
                    label="Upload CSV File"
                  />
                )}
              />
            </Col>
          </Row>
          <div className={styles.sampleText}>
            <Typography className={styles.sampleLabel}>
              {sampleFileName}
            </Typography>
            <a href={sampleFileLink} className={styles.downloadIcon}>
              <DownloadOutlined />
            </a>
          </div>

          <CustomButton
            onClick={handleUploadFile}
            title="Upload"
            type="submit"
            style={{
              width: "128px",
              height: "40px",
              margin: "0 0 0 auto",
            }}
            variant="outlined"
          />
        </div>
      </div>
    </CustomDrawer>
  );
};
export default UploadCsv;
